/**
 * Build a full URL for uploaded media (/uploads/...).
 * Prefers REACT_APP_MEDIA_URL (AWS S3 / CDN), otherwise REACT_APP_API.
 */
export function getMediaUrl(path?: string | null): string {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) {
    return path;
  }
  const base = (
    process.env.REACT_APP_MEDIA_URL ||
    process.env.REACT_APP_API ||
    ""
  ).replace(/\/+$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}
